import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { addPool } from '../../../actions/poolAddEdit'
import Wrapper from '../../../components/wrapper'
import RdsPartnerSelector from '../../../components/rdsPartnerSelector'
import TimeZoneSelector from '../../../components/timeZoneSelector'
import PropTypes from 'prop-types'
import { AsyncCreatable } from 'react-select'
import Loader from '../../../components/loader'
import Error from '../../../components/alerts/error'
import PoolApi from '../../../api/pools'
import { isMagicEnabledFromSearch } from '../../../helpers/tenant'

export class PoolsAdd extends React.Component {

  constructor(props) {
    super(props)
    this.submitPool = this.submitPool.bind(this)
    this.state = {
      name: '',
      timeZone: this.props.timeZones === null ? '' : this.props.timeZones[0],
      partnerSubscriptionId: '',
      nameIsValid: false,
      poolZone: null,
      overrideId: false,
      poolId: ''
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.timeZones !== this.props.timeZones) {
      this.setState((state) => {
        return {
          ...state,
          timeZone: this.props.timeZones[0]
        }
      })
    }
    if (prevProps.tenant !== this.props.tenant) {
      this.setState((state) => {
        return {
          ...state,
          partnerSubscriptionId: ''
        }
      })
    }
  }

  submitPool() {
    var poolId = this.state.overrideId ? this.state.poolId : null;

    this.props.addPool(
      {
        poolId: poolId,
        name: this.state.name,
        timeZone: this.state.timeZone,
        partnerSubscriptionId: this.state.partnerSubscriptionId,
        poolZone: this.state.poolZone
      })
  }

  IsInvalidForm() {
    return this.props.isSaving || this.state.name === '' || this.state.name === undefined
      || this.state.partnerSubscriptionId === undefined || this.state.partnerSubscriptionId === '' || this.state.partnerSubscriptionId === '0'
      || this.state.timeZone === '' || this.state.timeZone === undefined
  }

  getPoolZoneOptions(searchText) {
    return PoolApi.GetPoolZoneSuggestions(searchText)
      .then(response => response.json())
      .then(response => response.items.map(datum => ({ label: datum.poolZone, value: datum.poolZone })))
  }

  setOverrideId() {
    this.setState((state) => {
      return {
        ...state,
        overrideId: !state.overrideId
      }
    })
  }

  render() {
    return <Wrapper title={'Create Pool'} >
      <form className="col-lg-4 col-md-8 col-sm-12">
        {(this.props.error !== undefined && this.props.error !== '') ?
          <Error title="" body={this.props.error} /> : null
        }

        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input id="name" className={this.state.nameIsValid ? "form-control" : "form-control is-invalid"} placeholder="Name" onChange={(event) => {
            let val = event.target.value

            this.setState((state) => {
              return {
                ...state,
                name: val,
                nameIsValid: val !== undefined && val !== ''
              }
            })
          }} required />
        </div>
        <RdsPartnerSelector id="rdsPartnerSelector"
          onChange={(partnerSubscriptionId) => { this.setState((state) => { return { ...state, partnerSubscriptionId: partnerSubscriptionId } }) }}
        />
        <TimeZoneSelector timeZone={this.state.timeZone}
          onChange={(timeZone) => { this.setState((state) => { return { ...state, timeZone: timeZone } }) }}
        />
        <div className="form-group">
          <label htmlFor="selectPoolZoneInput">Pool Zone</label>
          <AsyncCreatable
            id="selectPoolZoneInput"
            classNamePrefix="selectPoolZoneInput"
            placeholder="Pool Zone"
            cacheOptions
            noOptionsMessage={() => null}
            onChange={(selected) => this.setState({ poolZone: selected.value })}
            value={{ label: this.state.poolZone, value: this.state.poolZone }}
            loadOptions={this.getPoolZoneOptions.bind(this)} />
        </div>

        <div className="form-check">
          <input id="overrideId" name="overrideId" type="checkbox" className="form-check-input" checked={this.state.overrideId} onChange={() => this.setOverrideId()} />
          <label htmlFor="overrideId"> Override Pool ID</label>
        </div>

        {this.state.overrideId &&
          <div className="form-group">
            <div className="alert alert-warning" role="alert">Some Delivery Partners require bespoke Delivery Pool Ids. Only change this value if you are sure.</div>
            <input className="form-control" id="poolId" placeholder="Pool ID" value={this.state.poolId} onChange={(event) => {
              let poolId = event.target.value
              this.setState((state) => {
                return {
                  ...state,
                  poolId: poolId
                }
              })
            }} />
          </div>
        }

        <span>
          <button id={'addPoolBtn'} disabled={this.IsInvalidForm()} type="submit" className='btn btn-primary' onClick={(event) => {
            event.preventDefault()
            this.submitPool()
          }} >Submit</button>
        </span>
        {(this.props.isLoading || this.props.isSaving) ? <Loader /> : null}
      </form>
    </Wrapper>
  }
}

PoolsAdd.propTypes = {
  addPool: PropTypes.func.isRequired,
  error: PropTypes.string,
  isLoading: PropTypes.bool,
  isSaving: PropTypes.bool,
  timeZones: PropTypes.arrayOf(PropTypes.string),
  tenant: PropTypes.string,
  isMagicEnabled: PropTypes.bool
}

PoolsAdd.defaultProps = {
  timeZones: [],
  tenant: ''
}

const mapStateToProps = (state, props) => {
  return {
    ...props,
    isLoading: state.rdsPartners.isLoading,
    isSaving: state.poolAddEdit.isSaving,
    error: state.poolAddEdit.error,
    timeZones: state.system.timeZones,
    tenant: state.system.tenant,
    isMagicEnabled: isMagicEnabledFromSearch(state.router && state.router.location && state.router.location.search)
  }
}

const mapDispatchToProps = dispatch => bindActionCreators({
  addPool
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(PoolsAdd)



// WEBPACK FOOTER //
// ./src/containers/pools/add/index.js